const READ = 'read';
const CREATE = 'create';
const EDIT = 'edit';
const SPECIFIC = 'SPECIFIC';
const ONLY_ME = 'ONLY_ME';
const CREATE_ARTICLE_ID = 'a9k3lz6xq0mf7v8u';
const KB_ARTICLE_MODULE = 'KB_ARTICLE';
const WHITELISTED_ATTR = {
  ADD_TAGS: ['iframe'],
  ADD_ATTR: [
    'filename',
    'hastrigger',
    'filesize',
    'filetype',
    'fileext',
    'url',
    'target',
    'contenteditable',
    'frameborder',
    'href',
    'allowfullscreen',
    'width',
    'height',
    'colwidth'
  ]
};
const ARTICLE_STATUS = {
  ARTICLE: {
    PUBLISHED: 'PUBLISHED',
    DRAFT: 'DRAFT'
  },
  FEEDBACK: {
    UNRESOLVED: 'UNRESOLVED',
    RESOLVED: 'RESOLVED'
  }
};

const supportedFormats = [
  {
    key: 'doc',
    variant: 'info'
  },
  {
    key: 'html',
    variant: 'success'
  },
  {
    key: 'pdf',
    variant: 'critical'
  }
];

const ALLOWED_MIME_TYPES = [
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
  'application/vnd.ms-word.document.macroEnabled.12',
  'application/vnd.ms-word.template.macroEnabled.12',
  'text/html',
  'application/xhtml+xml',
  'application/pdf'
].join(',');

const TITLE_MAP = {
  [READ]: {
    [ARTICLE_STATUS.ARTICLE.PUBLISHED]: 'common.app.kb.article.published.view',
    [ARTICLE_STATUS.ARTICLE.DRAFT]: 'common.app.kb.article.draft.view'
  },
  [CREATE]: 'common.app.kb.article.create',
  [EDIT]: 'common.app.kb.article.edit'
};

const ARTICLE_STATUS_BADGE = {
  PUBLISHED: {
    label: 'admin.policyMgmn.published',
    icon: 'PrivateArticlePlain',
    variant: 'success'
  },
  DRAFT: { label: 'quote.details.status.draft', icon: 'ReleaseNotes' }
};

const POPOVER_CONTENT = [
  {
    key: 'duplicate',
    iconName: 'Duplicate',
    label: 'common.label.duplicate',
    roleToCheck: 'knowledgeBase.add',
    show: true,
    modalProps: {
      title: 'common.app.kb.article.duplicate.title',
      description: 'common.app.kb.article.duplicate.description',
      primaryLabel: 'common.yes',
      primaryIcon: 'CircleTickThinOutline'
    }
  },
  {
    key: 'unpublish',
    iconName: 'ReleaseNotes',
    label: 'admin.policyMgmn.unpublish',
    roleToCheck: 'knowledgeBase.edit',
    show: true,
    modalProps: {
      title: 'common.app.kb.article.unpublish.title',
      description: 'common.app.kb.article.unpublish.description',
      primaryLabel: 'common.yes',
      primaryIcon: 'CircleTickThinOutline'
    }
  },
  {
    key: 'delete',
    iconName: 'Delete',
    label: 'common.delete',
    show: true,
    destructive: true,
    iconColor: 'red',
    roleToCheck: 'knowledgeBase.delete',
    modalProps: {
      title: 'common.warning',
      description: 'common.app.confirmation.delete.description',
      primaryLabel: 'app.confirmationModal.delete.btn',
      primaryIcon: 'Delete',
      destructive: true
    }
  },
  {
    key: 'discard',
    iconName: 'ReleaseNotes',
    label: 'admin.policyMgmn.unpublish',
    show: false,
    modalProps: {
      title: 'common.app.kb.article.unpublish.title',
      description: 'common.app.kb.article.unpublish.description',
      primaryLabel: 'common.yes',
      primaryIcon: 'Save'
    }
  }
];

const TOOLBAR_ACTIONS = {
  [CREATE]: [
    {
      key: 'draft',
      icon: 'Save',
      label: 'invoiceBuilder.actions.create.saveAsDraft'
    },
    {
      key: 'published',
      icon: 'CloudUpload',
      label: 'admin.customerSatisfaction.publish',
      buttonProps: {
        primary: true
      }
    }
  ],
  [READ]: {
    [ARTICLE_STATUS.ARTICLE.DRAFT]: [
      {
        key: 'actions',
        icon: 'Actions',
        popover: true,
        popoverContent: POPOVER_CONTENT.filter((el) => el.show)
      },
      {
        key: 'edit',
        icon: 'Edit',
        label: 'msp.common.label.edit.draft',
        roleToCheck: 'knowledgeBase.edit'
      },
      {
        key: 'published',
        icon: 'CloudUpload',
        label: 'admin.customerSatisfaction.publish',
        roleToCheck: 'knowledgeBase.edit',
        buttonProps: {
          primary: true
        }
      }
    ],
    [ARTICLE_STATUS.ARTICLE.PUBLISHED]: [
      {
        key: 'actions',
        icon: 'Actions',
        popover: true,
        popoverContent: POPOVER_CONTENT
      },
      {
        key: 'edit',
        icon: 'Edit',
        label: 'msp.common.label.edit.article',
        roleToCheck: 'knowledgeBase.edit'
      },
      {
        key: 'share',
        icon: 'Share',
        label: 'common.share'
      }
    ]
  },
  [EDIT]: [
    {
      key: 'cancel',
      label: 'common.cancel',
      buttonProps: {
        plain: true
      }
    },
    {
      key: 'draft',
      icon: 'Save',
      label: 'invoiceBuilder.actions.create.saveAsDraft'
    },
    {
      key: 'published',
      icon: 'CloudUpload',
      label: 'admin.customerSatisfaction.publish',
      buttonProps: {
        primary: true
      }
    }
  ]
};

const ARTICLE_METRICS = [
  {
    key: 'views',
    label: 'role.feature.taskViews',
    iconName: 'ViewCount'
  },
  {
    key: 'feedback',
    label: 'feedback.heading',
    iconName: 'ArticleFeedback'
  }
];

const ARTICLE_VISIBILITY = [
  {
    label: 'common.app.kb.article.share.link.access.title',
    description: 'common.app.kb.article.share.link.access.desc',
    key: 'SHARELINK',
    options: [
      {
        key: 'REQUIRED',
        label: 'common.app.kb.article.share.link.access.login.require',
        description: 'common.app.kb.article.visibilyt.all.requester.desc'
      },
      {
        key: 'NOT_REQUIRED',
        label: 'common.app.kb.article.share.link.access.login.not.require',
        description: null
      }
    ]
  },
  {
    label: 'client.details.user.header',
    description: 'common.app.kb.article.requester.access.desc',
    key: 'REQUESTER',
    tippyContent: 'common.app.kb.article.visibilty.requester.tippy.info',
    options: [
      {
        key: 'ALL',
        label: 'provisionRule.name.allRequesters',
        description: 'common.app.kb.article.visibilyt.all.requester.desc'
      },
      {
        key: 'SPECIFIC',
        label: 'common.app.kb.article.visibilyt.specific.requesters.label',
        description: null
      },
      // {
      //   key: 'SPECIFIC',
      //   label:
      //     'common.app.kb.article.visibilyt.specific.requesters.group.label',
      //   description: null
      // },
      {
        key: 'NONE',
        label: 'common.app.kb.article.visibilyt.no.requesters.label',
        description: 'common.app.kb.article.visibilyt.no.requester.desc'
      }
    ]
  },
  {
    label: 'role.feature.companyUsers',
    key: 'TECHNICIAN',
    description: 'common.app.kb.article.technician.access.desc',
    tippyContent: 'common.app.kb.article.visibilty.tehcnician.tippy.info',
    options: [
      {
        key: 'ONLY_ME',
        label: 'common.app.kb.article.visibility.onlyme',
        description: 'common.app.kb.article.visibility.onlyme.desc',
        status: 'DRAFT'
      },
      {
        key: 'ALL',
        label: 'admin.slaPolicy.escalationcard.h2.tech',
        description: 'common.app.kb.article.visibilyt.all.technician.desc'
      },
      {
        key: 'SPECIFIC',
        label: 'common.app.kb.article.visibilyt.specific.techgroup.label',
        description: null
      }
    ]
  }
];

const IMPORT_VISIBILITY = [
  {
    key: 'ONLY_ME',
    label: 'common.app.kb.article.visibility.onlyme',
    description: 'common.app.kb.article.visibility.onlyme.desc'
  },
  {
    key: 'ALL',
    label: 'admin.slaPolicy.escalationcard.h2.tech',
    description: 'common.app.kb.article.visibility.alltech.desc'
  },
  {
    key: 'SPECIFIC',
    label: 'dromo.title.technicianGroups',
    description: null
  }
];

const SUGGESTED_ARTICLES = [
  {
    key: 'REQUESTER',
    label: 'common.app.kb.article.suggestion.requester.articles'
  },
  {
    key: 'TECHNICIAN',
    label: 'common.app.kb.article.suggestion.technician.articles',
    hideInsertButton: true
  }
];

const EXPIRATION_UNITS = [
  { label: 'attribute.days', value: 'DAY' },
  { label: 'metric.quantity.hours', value: 'HOUR' }
];

export {
  READ,
  CREATE,
  EDIT,
  TITLE_MAP,
  WHITELISTED_ATTR,
  TOOLBAR_ACTIONS,
  SPECIFIC,
  ONLY_ME,
  CREATE_ARTICLE_ID,
  KB_ARTICLE_MODULE,
  ARTICLE_STATUS,
  ARTICLE_METRICS,
  ARTICLE_VISIBILITY,
  POPOVER_CONTENT,
  ARTICLE_STATUS_BADGE,
  ALLOWED_MIME_TYPES,
  IMPORT_VISIBILITY,
  supportedFormats,
  SUGGESTED_ARTICLES,
  EXPIRATION_UNITS
};
